import request from '@/utils/request'

// 获取子类型
export function chileType(data) {
	return request({
        url: '/api/chileType',
        params: data,
		method: 'get'
	})
}
// 获取导航栏
export function hotType(data) {
	return request({
        url: '/api/hotType',
        params:data,
		method: 'get'
	})
}

// 查看类型的所有文章
export function selArticleByType(data) {
	return request({
        url: '/api/selArticleByType',
        params: data,
		method: 'get'
	})
}

// 查看文章 
export function getArticle(data) {
	return request({
        url: '/api/getArticle',
        params: data,
		method: 'get'
	})
}
// 文章关键字联想
export function titleAssociation(data) {
	return request({
        url: '/api/titleAssociation',
        data,
		method: 'get'
	})
}

// 获取所有类型
export function findType() {
	return request({
        url: '/api/findType',
		method: 'get'
	})
}

// 文章查询
export function searchArticle(data) {
	return request({
        url: '/api/searchArticle',
		params: data,
		method: 'get'
	})
}